import {MODAL_WIDTH_LG} from '../../../../../styles/constants';
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {getFileMappingWizardCsvRowListCsvRows, hideFileMappingWizardCsvRowList,
        getFileMappingWizardRowListCalcRows } from './actions';
import EnhancedModal from '../../../../../components/enhanced-modal';
import {Button, Modal} from "antd";
import {getFilterObjFromViewerObj} from "../../../../../utils/filter";
import InfiniteScrollDataTable from "../../../../../components/infinite-scroll-data-table";
import {downloadTablePreview} from "../add-field/preview-row-list/actions"
import DatasetDownloadForm from '../add-field/preview-row-list/DatasetDownloadForm';

const mapStateToProps = state => ({
  isVisible: state.scenes.dataManager.fileMapping.components.wizard.components.csvRowList.isVisible,
  csvRows: state.scenes.dataManager.fileMapping.components.wizard.components.csvRowList.csvRows,
  calcField: state.scenes.dataManager.fileMapping.components.wizard.components.csvRowList.calcField,
  csvForm: state.scenes.dataManager.fileMapping.components.wizard.shared.csvForm,
  csvServerPath: state.scenes.dataManager.fileMapping.components.wizard.shared.csvServerPath,
  csvHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.csvHeader,
  fileFormat: state.scenes.dataManager.fileMapping.components.wizard.shared.fileFormat,
  tempTableName: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
  checkedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.checkedHeader,
  addFieldModalEditMode: state.scenes.dataManager.fileMapping.components.wizard.components.addField.addFieldModalEditMode,
});

const mapDispatchToProps = dispatch => ({
  onHide: () => dispatch(hideFileMappingWizardCsvRowList()),
  fetchCsvRows: (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, filePath, fileFormat) =>
    dispatch(getFileMappingWizardCsvRowListCsvRows(pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, filePath, fileFormat === 'plugin' ? 2 : 0)),
  fetchCalcRows: (pageNum, pageSize, filterTable, sortCols, sortByDesc, tableName, checkedHeader) =>
  dispatch(getFileMappingWizardRowListCalcRows(pageNum, pageSize, filterTable, sortCols, sortByDesc, tableName, checkedHeader)),
  onDownload: (tableName, separator, delimiter, functionQuery, aliasQuery, checkedHeaders, compression, isEdit) => dispatch(downloadTablePreview(tableName, separator, delimiter, functionQuery, aliasQuery, checkedHeaders, compression, isEdit))
});

const FileMappingWizardCsvRowList = ({
                                       t,
                                       isVisible,
                                       csvRows,
                                       csvForm,
                                       csvServerPath,
                                       csvHeader,
                                       fileFormat,
                                       onHide,
                                       fetchCsvRows,
                                       fetchCalcRows,
                                       tempTableName,
                                       calcField,
                                       onDownload,
                                       checkedHeader,
                                       addFieldModalEditMode
                                     }) =>
  <EnhancedModal
    visible={isVisible}
    onCancel={onHide}
    title={calcField === false ? t('scenes.dataManager.fileMapping.wizard.csvRowList.title') : t('scenes.dataManager.fileMapping.wizard.calcRowList.title')}
    width={MODAL_WIDTH_LG}
    footer={calcField === false ? <Button onClick={onHide}>{t('commons.buttons.close.title')}</Button> : 
        <div>
          <Button
            onClick={() => {
              let modal = Modal.info();
              modal.update({
                title: t("data.fileMapping.addField.downloadDataset.title"),
                content:
                  <DatasetDownloadForm
                    t={t}
                    modal={modal}
                    onDownload={
                      (separator, delimiter, compression) =>
                      onDownload(tempTableName, separator, delimiter, "", "", checkedHeader, compression, addFieldModalEditMode)
                    }
                  />,
                okButtonProps: {style: {display: 'none'}},
                cancelButtonProps: {style: {display: 'none'}},
                icon: 'download'
              })
            }}
            icon="download"
            type="primary"
          >
            {t('scenes.dataManager.fileMapping.wizard.download.label')}
          </Button>
          <Button onClick={onHide}>{t('commons.buttons.close.title')}</Button>
        </div>
    }
  >
    {csvForm !== null && csvHeader !== null && csvServerPath !== null && (
      <InfiniteScrollDataTable
        data={csvRows && csvRows.Data}
        rowTotal={csvRows && csvRows.Count}
        cols={csvRows && csvRows.Columns}
        hiddenCols={['NumRow']}
        onChange={
          ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) => {calcField === false ? (fetchCsvRows(
            pageNum,
            pageSize,
            getFilterObjFromViewerObj(
              csvRows && csvRows.Columns.filter(colName => colName !== 'NumRow'),
              searchText,
              filters
            ),
            sortCol ? [sortCol] : null,
            sortByDesc,
            csvForm.separator,
            csvForm.delimiter,
            csvForm.hasHeader,
            csvServerPath,
            fileFormat
          )) : (fetchCalcRows(
            pageNum,
            pageSize,
            getFilterObjFromViewerObj(
              csvRows && csvRows.Columns.filter(colName => colName !== 'NumRow'),
              searchText,
              filters
            ),
            sortCol ? [sortCol] : null,
            sortByDesc,
            tempTableName,
            checkedHeader
          ))
        }
        }
      />
    )}
  </EnhancedModal>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(FileMappingWizardCsvRowList);
